import { render, staticRenderFns } from "./DialogEmailTypeDepartment.vue?vue&type=template&id=25965881&scoped=true&"
import script from "./DialogEmailTypeDepartment.vue?vue&type=script&lang=js&"
export * from "./DialogEmailTypeDepartment.vue?vue&type=script&lang=js&"
import style0 from "./DialogEmailTypeDepartment.vue?vue&type=style&index=0&id=25965881&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25965881",
  null
  
)

export default component.exports